// removed by extract-text-webpack-plugin
module.exports = {"sidemenu-choices-wrapper":"sidemenu-choices-wrapper","sidemenu-column-wrapper":"sidemenu-column-wrapper","sidemenu-switch-wrapper":"sidemenu-switch-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SideMenu/SideMenu.scss
// module id = 5032
// module chunks = 1